import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {TicketsActions} from '../store';
import {TicketsSelectors} from '../store/selectors';

@Injectable()
export class TicketsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {
    return this.loadTicketsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadTicketsDone(): Observable<boolean> {
    return this.store.pipe(
      select(TicketsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          const params = {
            'order[createdAt]': 'desc'
          };
          this.store.dispatch(TicketsActions.ReadTickets({page: 1, params}));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
